const bgOptions: string[] = [
  '#57291F',
  '#C0413B',
  '#D77B5F',
  '#FF9200',
  '#C87505',
  '#F18E3F',
  '#C14C32',
  '#80003A',
  '#506432',
  '#B30019',
  '#EC410B',
  '#8CB5B5',
  '#6C3400',
  '#FFA400',
  '#41222A',
  '#FFB27B',
  '#BC7576',
];

export const genRandomPlaceholderBg = (): string => {
  const randomIndex = Math.floor(Math.random() * bgOptions.length);
  return bgOptions[randomIndex];
};

export const genPlaceholder = (
  text: string,
  size: 30 | 125,
  bgColor?: string,
  fontOptions?: {
    font?: string;
    fontWeight?: string;
    fontSize?: number;
    fontColor?: string;
  },
): HTMLCanvasElement => {
  const bg = bgColor ?? genRandomPlaceholderBg();
  const canvas = document.createElement('canvas');

  canvas.style.background = bg;
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');

  if (ctx) {
    const font = fontOptions?.font ?? 'Poppins';
    const fontWeight = fontOptions?.fontWeight ?? '600';
    const fontSize = fontOptions?.fontSize ?? 48;
    const fontColor = fontOptions?.fontColor ?? '#fff';

    ctx.font = `${fontWeight} ${fontSize}px/${fontSize}px ${font}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const horizontalCenter = canvas.width / 2;
    const verticalCenter = (canvas.height + 8) / 2;

    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = fontColor;
    ctx.fillText(text, horizontalCenter, verticalCenter);
  }

  return canvas;
};

export default genPlaceholder;
